module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('p', {
    staticClass: "content"
  }, [_c('b', [_vm._v("Selected:")]), _vm._v(" " + _vm._s(_vm.selected))]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Find or add a Fruit"
    }
  }, [_c('b-autocomplete', {
    ref: "autocomplete",
    attrs: {
      "data": _vm.filteredDataArray,
      "placeholder": "e.g. Orange"
    },
    on: {
      "select": function (option) { return _vm.selected = option; }
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('a', {
    on: {
      "click": _vm.showAddFruit
    }
  }, [_c('span', [_vm._v(" Add new... ")])])]), _vm._v(" "), _c('template', {
    slot: "empty"
  }, [_vm._v("No results for " + _vm._s(_vm.name))])], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-754ee99e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/autocomplete/examples/ExHeader.vue
// module id = 964
// module chunks = 6 170